<div class="form-row row">
  <div class="form-group" innerHTML="{{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.information' | translate }}">
  </div>
</div>
<form [formGroup]="configurationFormREST">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="isBearerToken">{{'i18n.domain.export-configuration.configurations.forms.rest.form-fields.access-management-type' | translate }}</label>
      <app-yes-no-group-button id="isBearerToken"
                               formControlName="isBearerToken"
                               i18nTranslationKeyPrefix="i18n.domain.export-configuration.configurations.yes-no-fields.is-bearer-token">
      </app-yes-no-group-button>
    </div>
  </div>
  @if (configurationFormREST.get('isBearerToken').value) {
    <div class="form-row row">
      <div class="form-group col-md-4">
        <label for="clientId" class="control-label">
          {{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.client-id' | translate }}
        </label>
        <input id="clientId"
               formControlName="clientId"
               class="form-control"
               type="text"
               readonly/>
        <app-error-messages [control]="configurationFormREST.get('clientId')"></app-error-messages>
      </div>
      <div class="form-group col-md-4">
        <label for="clientSecret" class="control-label required">
          {{'i18n.domain.export-configuration.configurations.forms.rest.form-fields.client-secret' | translate }}
        </label>
        <div class="wrap">
          <div class="password-generator-input e-input-group"
               [ngClass]="{'e-error': hasError(configurationFormREST.get('clientSecret'))}">
            <input class="e-input form-control"
                   id="clientSecret"
                   formControlName="clientSecret"
                   type="text"/>
            <span class="e-input-group-icon"
                title="{{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.client-secret-tooltip' | translate }}"
                (click)="configurationFormREST.get('clientSecret').setValue(generatePassword())">
              <span class="e-icons icon-reset--alt"></span>
            </span>
          </div>
          <app-error-messages [control]="configurationFormREST.get('clientSecret')"></app-error-messages>
        </div>
      </div>
    </div>
  }
  @if (!configurationFormREST.get('isBearerToken').value) {
    <div class="form-row row">
      <div class="form-group col-md-4">
        <label for="apiFixKey" class="control-label">
          {{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.api-key' | translate }}
        </label>
        <input id="apiFixKey"
               formControlName="apiFixKey"
               class="form-control"
               type="text"
               readonly/>
        <app-error-messages [control]="configurationFormREST.get('apiFixKey')"></app-error-messages>
      </div>
      <div class="form-group col-md-4">
        <label for="apiFixValue" class="control-label required">
          {{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.api-fix-value' | translate }}
        </label>
        <div class="wrap">
          <div class="password-generator-input e-input-group"
               [ngClass]="{'e-error': hasError(configurationFormREST.get('apiFixValue'))}">
            <input class="e-input form-control"
                   id="apiFixValue"
                   formControlName="apiFixValue"
                   type="text"/>
            <span class="e-input-group-icon">
              <span class="e-input-group-icon"
                    title="{{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.api-fix-value-tooltip' | translate }}"
                    (click)="configurationFormREST.get('apiFixValue').setValue(generatePassword())">
                <span class="e-icons icon-reset--alt"></span>
              </span>
            </span>
          </div>
          <app-error-messages [control]="configurationFormREST.get('apiFixValue')"></app-error-messages>
        </div>
      </div>
    </div>
  }
  @if (configurationFormREST.get('isBearerToken').value) {
    <div class="form-row row">
      <div class="form-group col-md-4 position-relative">
        <label for="refreshTokenLifetime"
               class="control-label required">
          {{'i18n.domain.export-configuration.configurations.forms.rest.form-fields.refresh-token-lifetime' | translate }}
        </label>
        <ejs-numerictextbox id="refreshTokenLifetime"
                            format="n0"
                            min="10"
                            formControlName="refreshTokenLifetime">
        </ejs-numerictextbox>
        <app-error-messages [control]="configurationFormREST.get('refreshTokenLifetime')"></app-error-messages>
        <span class="txt-suffix">h</span>
      </div>
    </div>
  }
</form>
